<template>
<div class="chapter">
<div class="inner_page">
<div class="figure">
<img alt="Bad Guys: A Gibbons and Tozzi Novel (Book 1)" src="images/cover_11188.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?3f571bc1